import { LoginDesktopView } from './LoginDesktopView';
import type { LoginProps } from '../pages/LoginPage';

export function LoginTabletView(props: LoginProps) {
  return <LoginDesktopView {...props} variant="tablet" />;
}
